import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Radio.module.scss';

export const Radio = ({
    active, onClick, className,
    value, label, children
}: Props) => {

    const classes = classNames(styles.default, className, {
        [styles.active]: active,
        'idt-active': active,
        'idt-inactive': !active
    });

    return (
        <div className={classes} onClick={() => onClick(value)} title={label}>
            <div className={styles.check}>
                <div className={styles.checkInner} />
            </div>

            <div className={styles.inner}>
                {children}
            </div>
        </div>
    );
};

export type RadioOption = {
    label: string;
    value: string;
};

type Props = PropsWithChildren<RadioOption & {
    active: boolean;
    onClick: (value: string) => void;
    className?: string;
}>;